import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';
 
@Injectable()
export class Interceptor implements HttpInterceptor {
  private helper: JwtHelperService = new JwtHelperService();
  private is401Handled: boolean = false;
 
  constructor(
    private router: Router,
    private toast: ToastrService,
    private authService: AuthService
  ) {}
 
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let token = localStorage.getItem('token');
    let isValidToken = true;
 
    try {
      isValidToken = token ? !this.helper.isTokenExpired(token) : false;
    } catch (err) {
      isValidToken = false;
    }
 
    if (!isValidToken && !localStorage.getItem('socialMedia')) {
      localStorage.clear();
      isValidToken = true;
    }
  //  console.log(typeof request?.body, request?.headers, request?.detectContentTypeHeader(), request?.url);
    // let headers = new HttpHeaders().set('Content-Type', 'application/json');
    let headers = request.headers;
    // Set Content-Type only when needed
  if (!this.isFromDataUrl(request.url) && !headers.has('Content-Type')) {
    headers = headers.set('Content-Type', 'application/json');
  }

  // ✅ DO NOT override Authorization if already present
  const hasAuthHeader = headers.has('Authorization');
 
    if(this.isFromDataUrl(request?.url)){
      console.log("in file part");
     headers =  new HttpHeaders()
    }

    if (
    !hasAuthHeader &&
    isValidToken &&
    token &&
    !this.isExcludedUrl(request.url)
  ) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }
 
    request = request.clone({ headers });
    const startTime = performance.now();
 
    return next.handle(request).pipe(
      finalize(() => {
        this.logRequestTime(startTime, request.url, request.method);
      }),
      catchError((error) => {
        this.handleHttpError(error, request?.url);
        return throwError(error);
      })
    );
  }
 
  private isExcludedUrl(url: string): boolean {
    return url.includes('_login/local') || url.includes('_login/facebook');
  }

  private isFromDataUrl(url: string): boolean {
    return url.includes('/single') || url.includes('/upload') || url.includes('/upload_binaries') || url.includes('xedge/v1/policy-matrix/profile');
  }
 
  private handleHttpError(error: any, url: any): void {
    if (error.status === 401 && !this.is401Handled && !localStorage.getItem('socialMedia')) {
      this.is401Handled = true;
      if(url.includes('login')){
      this.toast.warning(error?.error?.error?.message || 'Session Expired, Please Login');
      } else {
      this.toast.warning('Session Expired, Please Login');
      }
      localStorage.clear();
 
      setTimeout(() => {
        this.is401Handled = false;
        this.router.navigateByUrl('/login');
      }, 3000);
    } else if (error.status === 403) {
      this.toast.warning(error.error?.response?.message || 'No Access');
    } else if (error.status === 409) {
      this.toast.warning(error.error?.response?.message || 'Conflict occurred');
    } else if (error.status === 504) {
      this.toast.warning("CORS policy: No 'Access-Control-Allow-Origin'");
    }else if (error.status === 500) {
      this.toast.warning("Unable to reach the server!");
    }else if (error.status === 412) {
      console.log(error);
      if(url&&(url.includes("group_create_modify"))){
        this.toast.warning(error?.error?.result);
      }else if(url.includes("eventlogdata")){

      }
      else{
        this.toast.warning(`Internal error!`);
      }
      
    }
  } 
 
  private logRequestTime(startTime: number, url: string, method: string): void {
    const duration = performance.now() - startTime;
    // console.log(`HTTP ${method} ${url} - ${duration.toFixed(2)} ms`);
  }
}
 